// Generic whiteboard glyph; the component export is retained for API compatibility.
const LogoIcon = () => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    aria-hidden="true"
    className="ExcalidrawLogo-icon"
  >
    <rect
      x="5"
      y="5"
      width="30"
      height="24"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M13 35h14M20 29v6M11 13h18M11 19h12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const LogoText = () => <span className="ExcalidrawLogo-text">Whiteboard</span>;

type LogoSize = "xs" | "small" | "normal" | "large" | "custom" | "mobile";

interface LogoProps {
  size?: LogoSize;
  withText?: boolean;
  style?: React.CSSProperties;
  /**
   * If true, the logo will not be wrapped in a Link component.
   * The link prop will be ignored as well.
   * It will merely be a plain div.
   */
  isNotLink?: boolean;
}

export const ExcalidrawLogo = ({
  style,
  size = "small",
  withText,
}: LogoProps) => {
  return (
    <div className={`ExcalidrawLogo is-${size}`} style={style}>
      <LogoIcon />
      {withText && <LogoText />}
    </div>
  );
};
